import addDistrictDialogTemplate from "./addDistrictDialog/addDistrictDialog.html";
import addDistrictDialogController from "./addDistrictDialog/addDistrictDialog.controller";
class Controller {
  constructor(
    Events,
    $state,
    $stateParams,
    $mdDialog,
    Messages,
    Sections,
    District,
    CityHandler
  ) {
    "ngInject";

    this.Events = Events;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$mdDialog = $mdDialog;
    this.Messages = Messages;
    this.activeParams = this.$stateParams;
    this.sections = Sections.settingsSections;
    this.page = this.$stateParams.page;
    this.limit = this.$stateParams.limit;
    this.District = District;
    this.CityHandler = CityHandler;
    this.dashboardCity = this.CityHandler.get();
    this.filterEvent = this.Events.getFilterEvent("districts");
    this.paginateEvent = this.Events.getPaginateEvent("districts");
    this.sortEvent = this.Events.getSortEvent("districts");
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
  }
  openDialog() {
    this.$mdDialog
      .show({
        controller: addDistrictDialogController,
        controllerAs: "$ctrl",
        template: addDistrictDialogTemplate,
        locals: {},
      })
      .then(({ name, city: { _id } }) => {
        this.District.post({ name_i18n: name, city: _id })
          .$promise.then(({ _id: id }) => {
            this.Events.emit(
              this.successNotificationEvent,
              this.Messages.addMessage("District")
            );
            this.$state.transitionTo("district", {
              id,
            });
          })
          .catch((err) => {
            this.Events.emit(this.errorNotificationEvent, err.data);
          });
      });
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/districts/districts.controller.js